<h5 mat-dialog-title i18n>Dealer Engagement Report</h5>
<div mat-dialog-content>
  <p i18n>Please define the filters below</p>
</div>
<form #parameterForm="ngForm" (ngSubmit)="runReport(parameterForm)">
  <div class="form-group row">
    <div class="col-sm-6">
      <div class="control-wrapper">
        <div class="form-inline">
          <mat-checkbox class="mr-5" id="activeDealersOnly" name="activeDealersOnly" [(ngModel)]="data.activeDealersOnly" (change)="onCheckboxChange($event)" i18n>Active Dealers Only?</mat-checkbox>

          <!--<input type="checkbox" name="activeDealersOnly" id="activeDealersOnly" class="mr-1" [(ngModel)]="activeDealersOnly">
          Active Dealers Only?-->
        </div>
        <label for="dealerId" class="col-sm-3 col-form-label" i18n>Dealer</label>
        <select name="dealer_ID" id="dealer_ID"
                [(ngModel)]="data.dealerEngagement.dealer_ID" #dealer_ID="ngModel"
                class="form-control select-bidit">
          <option [ngValue]="null" i18n>All</option>
          <option *ngFor="let dealer of data.dealers" [ngValue]="dealer.dealer_ID">{{dealer.dealer_BusinessName}}</option>
        </select>
      </div>      
    </div>
    <div class="col-sm-6">
      <p i18n>Define Time Frame</p>
      <div class="control-wrapper">
        <label for="year" class="col-sm-3 col-form-label" i18n>Year</label>
        <select name="year" id="year"
                [(ngModel)]="data.dealerEngagement.year" #year="ngModel"
                class="form-control select-bidit">
          <option [ngValue]=null i18n>All</option>
          <option *ngFor="let year of data.years" [ngValue]="year">{{year}}</option>
        </select>
      </div>
      <div class="control-wrapper">
        <label for="startMonth" class="col-sm-3 col-form-label" i18n>Start Month</label>
        <select name="startMonth" id="startMonth"
                [(ngModel)]="data.dealerEngagement.startMonth" #startMonth="ngModel"
                class="form-control select-bidit">
          <option *ngFor="let month of data.months" [ngValue]="month.MonthNum">{{month.MonthName}}</option>
        </select>
      </div>
      <div class="control-wrapper">
        <label for="endMonth" class="col-sm-3 col-form-label" i18n>End Month</label>
        <select name="endMonth" id="endMonth"
                [(ngModel)]="data.dealerEngagement.endMonth" #endMonth="ngModel"
                class="form-control select-bidit">
          <option *ngFor="let month of data.months" [ngValue]="month.MonthNum">{{month.MonthName}}</option>
        </select>
      </div>
    </div>

  </div>
  <div class="form-group">
    <button type="submit" class="btn btn-bidit-submit mr-1" i18n>Submit</button>
    <button type="button" (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
  </div>
</form>

